import { defineComponent as _defineComponent } from 'vue'
import { ERROR404_PATH, isPathExists, removeQueryString } from '@/router';






export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


onLaunch(() => {





  // H5应用启动时检查当前路由是否有效
  // 直接从浏览器URL获取初始路径,不依赖getCurrentPages()
  const initialPath = window.location.pathname;
  const cleanPath = removeQueryString(initialPath);

  console.log('[App onLaunch] 初始路径:', initialPath, '清理后:', cleanPath);

  // 排除根路径和404页面本身
  if (cleanPath !== '/' && cleanPath !== ERROR404_PATH && !isPathExists(cleanPath)) {
    console.warn(`[路由检查] 路径不存在: ${cleanPath}, 即将跳转到404页面`);

    // 使用reLaunch确保强制跳转
    nextTick(() => {
      setTimeout(() => {
        uni.reLaunch({
          url: ERROR404_PATH,
          success: () => {
            console.log('[路由检查] 成功跳转到404页面');
          },
          fail: (err) => {
            console.error('[路由检查] 跳转404失败:', err);
          },
        });
      }, 100);
    });
  }

});

return () => {}
}

})